const getDateOnly = (value) => {
    if (!value) return null;
    const parsed = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(parsed.getTime())) return null;
    return new Date(parsed.getFullYear(), parsed.getMonth(), parsed.getDate());
};

export const isPastOkrWeek = (week, today = new Date()) => {
    const endDate = getDateOnly(week?.endDate);
    const todayDate = getDateOnly(today);
    return Boolean(endDate && todayDate && endDate < todayDate);
};

export const canSubmitOkrFromDashboard = ({
    roleUid,
    selectedCollaboratorId,
    currentUserCollaboratorId,
    week,
    result,
    today = new Date()
}) => {
    return getOkrSubmissionState({
        roleUid,
        selectedCollaboratorId,
        currentUserCollaboratorId,
        week,
        result,
        today
    }).canSubmit;
};

export const getOkrSubmissionState = ({
    roleUid,
    selectedCollaboratorId,
    currentUserCollaboratorId,
    week,
    result,
    today = new Date()
}) => {
    const canSubmitForSelectedOperator =
        roleUid === 'admin' ||
        roleUid === 'superAdmin' ||
        (roleUid === 'operator' &&
            Boolean(selectedCollaboratorId) &&
            String(selectedCollaboratorId) === String(currentUserCollaboratorId));

    if (!canSubmitForSelectedOperator || !selectedCollaboratorId) {
        return { canSubmit: false, reason: 'No permission' };
    }
    if (result?.status === 'approved') {
        return { canSubmit: false, reason: 'Approved' };
    }
    if (week?.isLocked || result?.entryLocked) {
        return { canSubmit: false, reason: 'Locked week' };
    }
    if (!isPastOkrWeek(week, today)) {
        return { canSubmit: false, reason: 'Available after the week closes' };
    }
    if (!result?.entryId) {
        return { canSubmit: false, reason: 'No weekly record' };
    }
    return { canSubmit: true, reason: null };
};

export const clampProgressPercentage = (value) => {
    const parsed = Number(value);
    if (!Number.isFinite(parsed)) return 0;
    return Math.min(100, Math.max(0, parsed));
};
